import React, { useEffect, useContext, useState } from "react";
import OrderField from "../shared/order_field";
import { useFormContext, Controller } from "react-hook-form";
import Select from "react-select";
import { OrderContext } from "../../../contexts/order_context";
import moment from "moment/src/moment";
import DateTime from "react-datetime";
import { isDDMMYYYY } from "../../../helpers";

const OrderCustomers = ({}) => {
  const { defaults } = useContext(OrderContext);
  const [validDates, setValidDates] = useState({});
  const {
    register,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors },
  } = useFormContext({
    defaultValues: {
      adults: { value: defaults.adults, label: defaults.adults },
      children: { value: defaults.children, label: defaults.children },
      rooms: { value: defaults.rooms, label: defaults.rooms },
      children_date_births: [],
    },
  });

  const ADULT_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const CHILD_OPTIONS = [0, 1, 2, 3, 4];
  const ROOM_OPTIONS = [1, 2];

  const children = watch("children");

  const getNumberAsOption = (number) => {
    return { value: number, label: number };
  };

  useEffect(() => {
    const adultsNumber = getNumberAsOption(defaults.adults);
    const childrenNumber = getNumberAsOption(defaults.children);
    const roomsNumber = getNumberAsOption(defaults.rooms);
    if (getValues("adults") != adultsNumber) setValue("adults", adultsNumber);
    if (getValues("children") != childrenNumber)
      setValue("children", childrenNumber);
    if (getValues("rooms") != roomsNumber) setValue("rooms", roomsNumber);
  }, []);

  useEffect(() => {
    for (let i = 3; i >= children?.value; i--) {
      setValue(`children_date_births.${i}`, undefined);
      setValidDates((prevDates) => {
        return { ...prevDates, [i]: false };
      });
    }
  }, [children?.value]);

  return (
    <OrderField title={I18n.t("js.order.fields.customers")}>
      <div className="row order-form__block-content">
        <div className="col-lg-6 main-content">
          <div className="form-group row">
            <label className="col-sm-7 col-md-6 col-lg-9">
              <i className="fas fa-male fa-2x" />
              {I18n.t("js.order.customers.adult")}
            </label>
            <Controller
              name="adults"
              className="select optional form-control col-sm-5 col-md-3 col-lg-3"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <div className="col-sm-5 col-md-3 col-lg-3">
                    <Select
                      options={ADULT_OPTIONS.map((i) => {
                        return { value: i, label: i };
                      })}
                      onChange={onChange}
                      value={value}
                      isSearchable={false}
                      placeholder=" "
                    />
                  </div>
                );
              }}
            />
          </div>
          <div className="form-group row">
            <label className="col-sm-7 col-md-6 col-lg-9">
              <i className="fas fa-child" />
              <span className="fa5-text">
                {I18n.t("js.order.customers.children")}
              </span>
            </label>
            <Controller
              name="children"
              className="select optional form-control col-sm-5 col-md-3 col-lg-3"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <div className="col-sm-5 col-md-3 col-lg-3">
                    <Select
                      options={CHILD_OPTIONS.map((i) => {
                        return { value: i, label: i };
                      })}
                      onChange={onChange}
                      value={value}
                      isSearchable={false}
                      placeholder=" "
                    />
                  </div>
                );
              }}
            />
          </div>
          {children &&
            [...Array(parseInt(children?.value))].map((_, i) => {
              return (
                <div className="form-group row" key={`child-${children}-${i}`}>
                  <label className="col-sm-7 col-md-8 col-lg-8">
                    <i className="fas fa-child" />
                    <span className="fa5-text">
                      {I18n.t("js.order.customers.child_date_birth", {
                        child_number: i + 1,
                      })}
                    </span>
                  </label>
                  <Controller
                    name={`children_date_births.${i}`}
                    control={control}
                    required
                    rules={{ required: true }}
                    render={({ field }) => {
                      return (
                        <div
                          className={`col-sm-5 col-md-4 col-lg-4 ${
                            validDates[i] ? "" : "redOutline"
                          }`}
                        >
                          <DateTime
                            {...field}
                            inputProps={{
                              placeholder: "dd.mm.yyyy",
                              required: true,
                            }}
                            dateFormat={"DD.MM.YYYY"}
                            timeFormat={false}
                            initialViewMode={"years"}
                            isValidDate={(currentDate) =>
                              currentDate <= moment().subtract(2, "years") &&
                              currentDate >= moment().subtract(12, "years")
                            }
                            onChange={(t) => {
                              setValidDates((prevDates) => {
                                return { ...prevDates, [i]: isDDMMYYYY(t) };
                              });
                              const currentDate = moment(t);
                              if (
                                isDDMMYYYY(t) &&
                                currentDate <= moment().subtract(2, "years") &&
                                currentDate >= moment().subtract(12, "years")
                              ) {
                                setValue(
                                  `children_date_births.${i}`,
                                  moment(t).format("DD.MM.YYYY")
                                );
                              }
                            }}
                            locale={"cs"}
                            utc={true}
                            closeOnSelect={true}
                          />
                        </div>
                      );
                    }}
                  />
                </div>
              );
            })}
          <div className="form-group row">
            <label className="col-sm-7 col-md-6 col-lg-9">
              <i className="fas fa-bed" />
              <span className="fa5-text">
                {I18n.t("js.order.customers.rooms")}
              </span>
            </label>

            <Controller
              name="rooms"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <div className="col-sm-5 col-md-3 col-lg-3">
                    <Select
                      options={ROOM_OPTIONS.map((i) => {
                        return { value: i, label: i };
                      })}
                      onChange={onChange}
                      value={value}
                      isSearchable={false}
                      placeholder=" "
                    />
                  </div>
                );
              }}
            />
          </div>
          <div className="form-group row">
            <label className="col-sm-5 col-md-4 col-lg-5">
              <i className="fas fa-envelope" />
              <span className="fa5-text">
                {I18n.t("js.order.customers.email")}
              </span>
            </label>
            <div className="col-sm-7 col-md-8 col-lg-7">
              <input
                className="string email required form-control"
                type="email"
                required={true}
                {...register("email", { required: true })}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 aside-content">
          <div className="alert alert--col">
            <i className="fas fa-baby" />
            <p
              dangerouslySetInnerHTML={{
                __html: I18n.t("js.order.customers.hint_children"),
              }}
            />
          </div>
        </div>
      </div>
    </OrderField>
  );
};

export default OrderCustomers;
